const utils = (() => {
  const ISO_VALUES = {
    A: 10,
    B: 12,
    C: 13,
    D: 14,
    E: 15,
    F: 16,
    G: 17,
    H: 18,
    I: 19,
    J: 20,
    K: 21,
    L: 23,
    M: 24,
    N: 25,
    O: 26,
    P: 27,
    Q: 28,
    R: 29,
    S: 30,
    T: 31,
    U: 32,
    V: 34,
    W: 35,
    X: 36,
    Y: 37,
    Z: 38,
  };

  const calcCheckDigit = (code: string): number => {
    const base = code.slice(0, 10);
    const sum = Array.from(base).reduce(
      (acc, c, i) =>
        acc + ((/\d/.test(c) ? +c : ISO_VALUES[c as keyof typeof ISO_VALUES]) ?? 0) * 2 ** i,
      0,
    );
    const mod = sum % 11;
    return mod === 10 ? 0 : mod;
  };

  const test = (num = '', withoutISOcheck = false): boolean => {
    const code = num.toUpperCase().replace(/\s+/g, '');

    if (!/^[A-Z]{4}\d{7}$/.test(code)) return false;
    if (withoutISOcheck) return true;

    const checkDigit = calcCheckDigit(code);
    const provided = parseInt(code[10], 10);
    return checkDigit === provided;
  };

  return { test };
})();

export const containerValidator = (str: any, withoutISOcheck = false) =>
  utils.test(str, withoutISOcheck);

export const extendContainerValidator = (value: any = '') => {
  const lengthDifference = 11 - value.length;
  if (lengthDifference <= 0) return containerValidator(value, true);
  let finalValue = value;
  const count = {
    digits: 0,
    letters: 0,
  };
  for (const char of value) {
    const code = char.charCodeAt(0);
    if (code >= 48 && code <= 57) {
      count.digits++;
    }

    if (code >= 65 && code <= 90) {
      count.letters++;
    }
  }

  const digitsLengthDifference = 7 - count.digits;
  const lettersLengthDifference = 4 - count.letters;
  for (let i = 0; i < lettersLengthDifference; i++) {
    if (digitsLengthDifference === 7) finalValue = finalValue + 'Z';
    if (digitsLengthDifference !== 7) finalValue = 'Z' + finalValue;
  }
  for (let i = 0; i < digitsLengthDifference; i++) {
    finalValue += 1;
  }

  return containerValidator(finalValue, true);
};
